import { useMemo } from "react";
import { useWorkOrdersInfiniteQuery } from "../../../../entities/work-order";
import { useDebounce } from "../../../../shared/hooks/useDebounce";
import {
  mapFiltersFormToApi,
  WorkOrderFiltersForm,
} from "./workOrderFilters.types";
import {
  toWorkOrderFiltersForm,
  useWorkOrderFiltersParams,
} from "./useWorkOrderFiltersParams";

const PAGE_LIMIT = 20;

export function useWorkOrderFilters() {
  const [params, setParams] = useWorkOrderFiltersParams();

  const filters = useMemo<WorkOrderFiltersForm>(
    () => toWorkOrderFiltersForm(params),
    [params],
  );

  const debouncedFilters = useDebounce(filters, 400);

  const apiFilters = useMemo(
    () => mapFiltersFormToApi(debouncedFilters, PAGE_LIMIT),
    [debouncedFilters],
  );

  const query = useWorkOrdersInfiniteQuery(apiFilters);

  return {
    filters,
    setFilters: setParams,
    apiFilters,
    ...query,
  };
}
